// Define a type for individual image size objects

type ImageSize = {
  mediaQuery: string;
  imageWidth: number;
};

// Define a type for the entire desktopImageSizes object

export type ImageSizesConfig = {
  imageSizes: ImageSize[];
  fileExtension: string;
  progressive: boolean;
  quality: number;
};

const desktopImageSizes: ImageSizesConfig = {
  imageSizes: [
    {
      mediaQuery: '(min-width: 2400px)',
      imageWidth: 1600,
    },
    {
      mediaQuery: '(min-width: 2048px)',
      imageWidth: 1080,
    },
    {
      mediaQuery: '(min-width: 1920)',
      imageWidth: 900,
    },
    { mediaQuery: '(min-width: 1200px)', imageWidth: 800 },
    {
      mediaQuery: '(min-width: 1024px)',
      imageWidth: 540,
    },
    {
      mediaQuery: '',
      imageWidth: 450,
    },
    {
      mediaQuery: '(min-width: 1536px)',
      imageWidth: 400 * 2,
    },
    {
      mediaQuery: '',
      imageWidth: 400,
    },
  ],
  fileExtension: 'jpg',
  progressive: true,
  quality: 85,
};

const mobileSmallTileImageSizes: ImageSizesConfig = {
  imageSizes: [
    {
      mediaQuery: '(min-width: 980px)',
      imageWidth: 1000,
    },
    {
      mediaQuery: '(min-width: 640px)',
      imageWidth: 800,
    },
    {
      mediaQuery: '(min-width: 480px)',
      imageWidth: 540,
    },
    {
      mediaQuery: '(min-width: 320px)',
      imageWidth: 400,
    },
    {
      mediaQuery: '',
      imageWidth: 400,
    },
  ],
  fileExtension: 'jpg',
  progressive: true,
  quality: 85,
};

const mobileLargeTileImageSizes: ImageSizesConfig = {
  imageSizes: [
    {
      mediaQuery: '(min-width: 980px)',
      imageWidth: 1200,
    },
    {
      mediaQuery: '(min-width: 640px)',
      imageWidth: 920,
    },
    {
      mediaQuery: '(min-width: 480px)',
      imageWidth: 720,
    },
    {
      mediaQuery: '(min-width: 320px)',
      imageWidth: 430,
    },
    {
      mediaQuery: '',
      imageWidth: 430,
    },
  ],
  fileExtension: 'jpg',
  progressive: true,
  quality: 85,
};

export {
  desktopImageSizes,
  mobileLargeTileImageSizes,
  mobileSmallTileImageSizes,
};
